import React from "react";
import { useTranslation } from "react-i18next";
import { Edit } from "lucide-react"; // icon for rating stars
import { LoyaltyOffer } from "../../../types/modules/admin/loyaltyOffer.type";
import LoyaltyOfferItem from "./LoyaltyOfferItem";
import { PermissionGate } from "../PermissionGate";
import { PermissionsKey } from "../../../data/permissions";

interface Props {
  data: LoyaltyOffer[];
}

const LoyaltyOffersListTable: React.FC<Props> = ({ data }) => {
  const { t } = useTranslation();

  return (
    <div className="overflow-x-auto">
      <table className="w-full border-separate border-spacing-y-5">
        <thead>
          <tr className="text-start text-sm text-DarkGrey2 font-semibold">
            <th className="p-3 font-normal capitalize">{t("id")}</th>
            <th className="p-3 font-normal capitalize">{t("amountRequired")}</th>
            <th className="p-3 font-normal capitalize">{t("bonusAmount")}</th>
            <th className="p-3 font-normal capitalize">{t("startDate")}</th>
            <th className="p-3 font-normal capitalize">{t("endDate")}</th>
            <PermissionGate permissions={[PermissionsKey.UpdateLoyaltyOffer]}>
              <>
              <th className="p-3 font-normal capitalize">{t("active")}</th>
              <th className="p-3 font-normal capitalize">{t("actions")}</th>
              </>
            </PermissionGate>
          </tr>
        </thead>
        <tbody className="text-sm">
          {data.map((da, index) => (
            <tr
              key={da.id}
              className="bg-white rounded-[12px]"
              style={{ boxShadow: "0px 4px 32px rgba(86, 92, 120, 0.08)" }}
            >
             <LoyaltyOfferItem item={da}/>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
export default LoyaltyOffersListTable;